<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { ProgramTypeService } from "../../../services/programType.service";
export default {
  name: "ProgramTypeCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.program_type_create"),
      createForm: [
        {
          label: this.$t("program_type.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_type.description"),
          name: "description",
          value: "",
          type: "input",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "ProgramTypeList" });
    },
    async submitForm(params) {
      const response = await new ProgramTypeService().create(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("program_type.name"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "ProgramTypeList" }), 500);
    }
  }
};
</script>

<style scoped></style>
